import React from 'react';

import { DesktopAnimation } from './desktop-animation';
import { LoadingAnimation } from './loading-animation';
import { SuccessAnimation } from './success-animation';

interface AnimationProps {
  isDesktop: boolean;
  finished: boolean;
  width: number;
  height: number;
  rbiOrderId?: string;
  navigateToOrderConfirmation?: () => void;
}

export const Animation: React.FC<AnimationProps> = ({
  isDesktop,
  finished,
  width,
  height,
  rbiOrderId,
  navigateToOrderConfirmation,
}) => {
  if (isDesktop) {
    return <DesktopAnimation />;
  }

  if (finished) {
    return (
      <SuccessAnimation
        width={width}
        height={height}
        rbiOrderId={rbiOrderId}
        navigateToOrderConfirmation={navigateToOrderConfirmation}
      />
    );
  }

  return <LoadingAnimation width={width} height={height} />;
};
